import { useEffect, useMemo, useState } from "react";
import useAxios from "../utils/useAxios";
import { useRef } from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import AsyncSelect from "react-select/async";
import { useAppContext } from "../context/AppContext";
import { currentDateAndTime } from "../utils/generateCurrentDateAndTime";
import { useNavigate } from "react-router-dom";
import { showModal, hideModal } from "../utils/modalUtility";
import Loader from "../components/common/Loader";
import Pagination from "../components/common/Pagination";
import { useAgencies } from "../hooks/useAgencies";
import { useModes } from "../hooks/useModes.js";

function Donations() {
  const [loading, setLoading] = useState(true);
  const [isEditMode, setIsEditMode] = useState(false);
  const [currentUserId, setCurrentUserId] = useState(null);
  const [sbiDonations, setSbiDonations] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [showPdfModal, setShowPdfModal] = useState(false);
  const [receiptDetails, setReceiptDetails] = useState({});
  const [role, setRole] = useState(null);
  const [view, setView] = useState("excel"); // default: show Excel section
  const [excelFile, setExcelFile] = useState(null);
  const [donorDetails, setDonorDetails] = useState([]);
  const [message, setMessage] = useState("");
  const [downloading, setDownloading] = useState(false);
  const [shouldFetch, setShouldFetch] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [uploadRows, setUploadRows] = useState([]);
  const [errors, setErrors] = useState({});

  const [donationSumarry, setDonationSummary] = useState([]);
  const [leads, setLeads] = useState([]);

  const [addDonationLoading, setAddDonationLoading] = useState(false);
  const { agencies, loading: agenciesLoading } = useAgencies();
  const { modes, loading: modesLoading } = useModes();

  const [activeTab, setActiveTab] = useState("All Donations");

  const { state } = useAppContext();

  const navigate = useNavigate();
  const { data, loading: donorLoading } = state;

  // console.log("Data ",data)

  const [filters, setFilters] = useState({
    search: "",
    from_date: "",
    to_date: "",
  });

  const handleFilterChange = (key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
  };

  const [formData, setFormData] = useState({
    user_id: "",
    transaction_date_and_time: "",
    amount: "",
    tr_no: "",
    mode: "CASH",
    name: "",
    phone_number: "",
    email: "",
    address: "",
    zipcode: "",
    donation_type: "one_time_donation",
    is_ehundi: "no",
    pan_no: "",
    processing_agency: "",
  });

  const mappedLeads = (Array.isArray(leads) ? leads : []).map((lead) => ({
    id: "U" + (100 + (lead?.id || 0)), // U101, U102, ...
    full_name: lead?.name || "", // map `name` to `full_name`
    phone_number: lead?.phone_number || "",
    donor_id: "U" + (100 + (lead?.id || 0)), // if donor_id is missing
    flag: "yes",
  }));

  // console.log("Map leads", mappedLeads);

  const filteredOptions = useMemo(() => {
    // Combine donor data and leads data
    const combinedData = [...(data || []), ...mappedLeads];
    // console.log("Combine data", combinedData);
    return combinedData
      .filter((user) => {
        const nameMatch = user.full_name
          ?.toLowerCase()
          .includes(searchTerm.toLowerCase());
        const phoneMatch = user.phone_number
          ?.toString()
          .includes(searchTerm.toLowerCase());
        return nameMatch || phoneMatch;
      })
      .slice(0, 50)
      .map((user) => ({
        value: user.id || "",
        label: `${user.full_name} - ${user.phone_number || ""} - ${
          user.donor_id || ""
        }`,
        flag: user.flag || "", // <-- add flag here,
        phone_number: user.phone_number, // optional, directly access
        full_name: user.full_name, // optional, directly access
      }));
  }, [data, searchTerm]);

  const loadOptions = (inputValue, callback) => {
    setSearchTerm(inputValue);
    callback(filteredOptions);
  };

  // console.log("Filter Option", filteredOptions);

  useEffect(() => {
    if (formData.user_id) {
      // filteredOptions is your array of options or you can fetch full user info
      const option =
        filteredOptions.find((opt) => opt.value === formData.user_id) || null;
      // console.log("Option", option);
      setSelectedUser(option);
    } else {
      setSelectedUser(null);
    }
  }, [formData.user_id, filteredOptions]);

  const removeFormData = () => {
    setFormData({
      user_id: "",
      transaction_date_and_time: "",
      amount: "",
      tr_no: "",
      mode: "",
      name: "",
      phone_number: "",
      email: "",
      address: "",
      zipcode: "",
      donation_type: "",
      pan_no: "",
      processing_agency: "",
    });
  };

  const handleResetFilters = () => {
    setFilters({
      search: "",
      from_date: "",
      to_date: "",
    });
    setPage(1);
    setShouldFetch(true);
  };

  useEffect(() => {
    if (shouldFetch) {
      fetchDonations();
      setShouldFetch(false); // reset trigger
    }
  }, [shouldFetch]);

  const axiosAPI = useAxios();
  const fileInputRef = useRef();
  const receiptRef = useRef();

  const handleExcelFileChange = (e) => {
    const file = e.target.files[0];
    if (
      file &&
      file.type !==
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ) {
      alert("Please upload a valid Excel file (.xlsx)");
      setExcelFile(null);
      if (fileInputRef.current) {
        fileInputRef.current.value = null; // Reset input field
      }
    } else {
      setExcelFile(file);
    }
  };

  // async function fetchCurrentTrNumber() {
  //   setLoading(true);
  //   try {
  //     const res = await axiosAPI.get(`/api/donation/current-tr-number`);
  //     // console.log(res.data?.current_tr_number);
  //     let TrNumber = "";
  //     if (res.data && res.data.current_tr_number) {
  //       TrNumber = res.data.current_tr_number.toString().padStart(6, "0");
  //     }
  //     TrNumber = TrNumbePrefix + TrNumber;

  //     setFormData((prev) => ({
  //       ...prev,
  //       tr_no: TrNumber,
  //     }));
  //   } catch (err) {
  //     console.error("Error fetching:", err);
  //   } finally {
  //     setLoading(false); // Always stops loading
  //   }
  // }

  // const handleExcelSubmit = async (e) => {
  //   e.preventDefault();

  //   if (!excelFile) {
  //     alert("Please select an Excel file.");
  //     return;
  //   }

  //   const formData = new FormData();
  //   formData.append("excel", excelFile);

  //   try {
  //     const response = await axiosAPI.post(
  //       "/api/donation/upload-excel",
  //       formData,
  //       {
  //         headers: {
  //           "Content-Type": "multipart/form-data",
  //         },
  //       }
  //     );

  //     setMessage(response.data.message || "Excel uploaded successfully!");
  //     closeModal();
  //     hideModal("newUserExcelModal");
  //     // fetchDonors();

  //     window.notifyMessage(
  //       "Success",
  //       "Excel file uploaded successfully!",
  //       "success"
  //     );

  //     //  Reset file input
  //     fileInputRef.current.value = null;
  //     setExcelFile(null);
  //     setMessage("");
  //     fetchDonations();
  //   } catch (err) {
  //     console.error("Excel Upload Error:", err);
  //     alert("Failed to upload Excel file.");
  //   }
  // };

  const handleExcelSubmit = async (e) => {
    e.preventDefault();

    if (!excelFile) {
      alert("Please select an Excel file.");
      return;
    }

    const formData = new FormData();
    formData.append("excel", excelFile);
    formData.append("upload_date_and_time", currentDateAndTime());

    try {
      const response = await axiosAPI.post(
        "/api/donation/upload-excel",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      const {
        message = "Upload completed",
        insertedCount = 0,
        rows = [],
        failedExcelBase64,
      } = response.data;

      //  Add this next
      if (failedExcelBase64) {
        const binaryString = atob(failedExcelBase64);
        const len = binaryString.length;
        const bytes = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
          bytes[i] = binaryString.charCodeAt(i);
        }
        const blob = new Blob([bytes], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "failed_rows.xlsx"; // You can change this filename if needed
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }

      // Set upload rows for summary table (if needed in UI)
      setUploadRows && setUploadRows(rows);

      const failedRows = rows.filter((r) => r.status === "fail");
      const passedRows = rows.filter((r) => r.status === "pass");

      // console.log("Upload Summary:", {
      //   insertedCount,
      //   passed: passedRows.length,
      //   failed: failedRows.length,
      // });

      //  Fix: Check if rows were even processed
      if (rows.length === 0) {
        window.notifyMessage(
          "Error",
          "No valid data found in Excel file.",
          "error",
        );
      } else if (insertedCount === 0 && failedRows.length > 0) {
        window.notifyMessage(
          "Upload Failed",
          `No rows were inserted.\nFailed Rows: ${failedRows.length}`,
          "error",
        );
        console.table(failedRows);
      } else if (failedRows.length > 0) {
        window.notifyMessage(
          "Partial Success",
          `${message}\nInserted: ${insertedCount}, Failed: ${failedRows.length}`,
          "warning",
        );
        console.table(failedRows);
      } else {
        window.notifyMessage(
          "Success",
          "Excel file uploaded successfully!",
          "success",
        );
      }

      // Close modal and reset form
      // closeModal();
      // hideModal("newGiftExcelModal");

      // Refresh donation list
      fetchDonations();

      // Clear input and state
      if (fileInputRef.current) {
        fileInputRef.current.value = null;
      }

      setExcelFile(null);
      setMessage("");
    } catch (err) {
      console.error("Excel Upload Error:", err);

      const errorMsg =
        err?.response?.data?.message ||
        "Something went wrong while uploading the Excel file.";

      window.notifyMessage("Error", errorMsg, "error");

      if (err.response?.data?.error) {
        console.error("Backend Error:", err.response.data.error);
      }
    }
  };

  const buildQuery = () => {
    const params = new URLSearchParams();

    Object.entries(filters).forEach(([key, value]) => {
      if (value) params.append(key, value);
    });

    params.append("page", page);
    return params.toString();
  };

  const downloadPdf = () => {
    const input = receiptRef.current;

    html2canvas(input, {
      scale: 2,
      useCORS: true, // Enable CORS to allow external images to be loaded
      allowTaint: true, // Allow tainting the canvas
    }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
      pdf.save(`DonationReceipt_${receiptDetails?.full_name || "User"}.pdf`);
    });

    setShowPdfModal(false);
    setReceiptDetails("");
  };

  // const fetchReceiptDetails = async (id) => {
  //   try {
  //     const response = await axiosAPI.get(
  //       `/api/donation/download-donation-receipt/${id}`
  //     );

  //     console.log("Reponse", response.data.user_details);

  //     let TrNumber = "";
  //     if (response.data && response.data.user_details.tr_number) {
  //       TrNumber = response.data.user_details.tr_number.padStart(6, "0");
  //     }

  //     TrNumber = TrNumbePrefix + TrNumber;

  //     const data = (response.data.user_details.tr_number = TrNumber);

  //     console.log(data);

  //     setReceiptDetails(response.data.user_details);
  //   } catch (error) {
  //     console.error(error);
  //     setLoading(false);
  //   }
  // };

  const fetchReceiptDetails = async (id) => {
    setLoading(true);
    try {
      const response = await axiosAPI.get(
        `/api/donation/download-donation-receipt/${id}`,
      );

      const userDetails = response.data.user_details;
      let TrNumber = "";

      // Only add prefix if tr_number exists and is a number
      // if (userDetails?.tr_number && !isNaN(userDetails.tr_number)) {
      //   TrNumber = userDetails.tr_number.toString().padStart(6, "0");
      //   TrNumber = TrNumbePrefix + TrNumber;
      //   userDetails.tr_number = TrNumber;
      // }

      // console.log("Final user details with TR number:", userDetails);

      setReceiptDetails(userDetails);
    } catch (error) {
      console.error("Error fetching receipt details:", error);
    } finally {
      setLoading(false);
    }
  };

  const openReceiptModal = (id) => {
    // Find the donation with this ID and populate the form
    const selecteRecurrer = sbiDonations.find((donor) => donor.id === id);

    fetchReceiptDetails(id);
    setShowPdfModal(true);
    // console.log("Receipt", receiptDetails);
  };

  // useEffect(() => {
  //   fetchDonations();
  // }, [filters, page]);

  function fetchDonations() {
    setLoading(true);
    const queryString = buildQuery();

    // console.log("query ", queryString);
    // return

    axiosAPI
      .get(`/api/donation/get-sbi-donation?${queryString}`)
      .then((res) => {
        // console.log("Response", res);
        // console.log(res.data.results)
        setSbiDonations(res.data.results);
        setTotalPages(res.data.totalPages);
      })
      .catch((err) => {
        console.error("Error fetching SBI donations:", err);
      })
      .finally(() => {
        setLoading(false); //  Always stops loading
      });
  }

  function fetchOneTimeDonationLeads() {
    setLoading(true);

    axiosAPI
      .get(`/api/donation/get-one-time-donation-leads`)
      .then((res) => {
        if (res && res.data && Array.isArray(res.data.data)) {
          setLeads(res.data.data);
        } else {
          setLeads([]);
        }
      })
      .catch((err) => {
        console.error("Error fetching SBI donations:", err);
        setLeads([]);
      })
      .finally(() => {
        setLoading(false); //  Always stops loading
      });
  }

  useEffect(() => {
    fetchDonations();
    fetchOneTimeDonationLeads();
  }, [page]);

  // useEffect(() => {
  //   getNotifications();
  //   // getSbiDonation()
  // }, []);

  useEffect(() => {
    // const role = JSON.parse(localStorage.getItem("user_role")); // Parses string "admin" to plain string

    setRole(state?.user?.role);
  }, []);

  // Get All Donor Details
  const getDonorDetails = async () => {
    try {
      const response = await axiosAPI.get("/api/donor/get-donor-details");
      setDonorDetails(response.data.data);
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  function fetchCurrentDateAndTime() {
    const now = new Date();

    // Manually format the date and time to "YYYY-MM-DD HH:MM"
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0"); // Month is 0-indexed, so we add 1
    const day = String(now.getDate()).padStart(2, "0");
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");

    // Combine the date and time into the desired format
    const formattedDateTime = `${year}-${month}-${day} ${hours}:${minutes}`;

    setFormData((prev) => ({
      ...prev,
      transaction_date_and_time: formattedDateTime,
    }));
  }

  async function fetchDonationSummary() {
    try {
      const response = await axiosAPI.get("/api/donation/get-donation-summary");
      setDonationSummary(response.data);
      setLoading(false);
    } catch (error) {
      console.error(error);
    }
  }

  // Set current date and time when the form loads
  useEffect(() => {
    fetchCurrentDateAndTime();
    fetchDonationSummary();
    getDonorDetails();
  }, []);

  const normalizePhone = (phone) =>
    phone?.toString().replace(/\D/g, "").slice(-10); // last 10 digits only

  const processedOptions = data
    .filter((user) => {
      const nameMatch = user.full_name?.toLowerCase();
      const phoneMatch = user.phone_number?.toString();
      return nameMatch || phoneMatch;
    })
    .map((user) => ({
      value: user.id,
      label: `${user.full_name} - ${user.phone_number || ""} - ${
        user.donor_id || ""
      }`,
      normalizedPhone: normalizePhone(user.phone_number),
    }));

  const handleChange = (e) => {
    const { id, value } = e.target;

    // console.log("ID", id);
    // console.log("Value", value);

    // console.log("Filter options", filteredOptions);

    if (id === "phone_number") {
      // const matchedOption = filteredOptions.find((option) =>
      //   // option.label.split("-")[1].trim().includes(value)
      //   option.label.split("-")[1].trim() == value
      // );

      // Then find matched option based on phone number
      const matchedOption = processedOptions.find(
        (option) => normalizePhone(value) === option.normalizedPhone,
      );

      // console.log("matchedOption", matchedOption);

      if (matchedOption) {
        setFormData({
          ...formData,
          phone_number: value,
          name: matchedOption.label.split("-")[0].trim(),
          user_id: matchedOption,
        });
      } else {
        setFormData({
          ...formData,
          phone_number: value,
          user_id: "", // clear user_id if no match
        });
      }
    } else if (id === "name") {
      setFormData({
        ...formData,
        name: value,
        user_id: "",
      });
    }

    // else if (id === "mode") {
    //   setFormData((prev) => ({
    //     ...prev,
    //     mode: value,
    //   }));

    //   //  Trigger API only when mode = "Online" or Upi
    //   if (!isEditMode && value === "Online" || value === "Upi") {
    //     fetchOnlineTrNumber();
    //   } else {
    //     fetchCurrentTrNumber();
    //   }
    // }
    else if (id === "mode") {
      setFormData((prev) => ({
        ...prev,
        mode: value,
      }));

      //  Only trigger when NOT in edit mode
      // if (!isEditMode) {
      //   // if (value === "Online" || value === "Upi") {
      //   //   fetchOnlineTrNumber();
      //   // }
      //   //  else {
      //   //   fetchCurrentTrNumber();
      //   // }
      // }
    } else {
      setFormData({
        ...formData,
        [id]: value,
      });
    }
  };

  const handlePageClick = (pageNum) => {
    if (pageNum >= 1 && pageNum <= totalPages) {
      setPage(pageNum);
    }
  };

  // console.log("Select user", formData);

  // Handle Submit (Add or Edit)
  const handleSubmit = async (e) => {
    e.preventDefault();

    // console.log("Clicked")

    const payload = {
      user_id: formData.user_id ? formData.user_id.value : null,
      transaction_date_and_time: formData.transaction_date_and_time,
      // amount: parseInt(formData.amount, 10), //  ensures INT for DB
      amount: parseInt(formData.amount, 10) || 0,
      tr_no: formData.tr_no,
      mode: formData.mode || "Online",
      phone_number: formData.phone_number,
      name: formData.name,
      email: formData.email,
      address: formData.address,
      zipcode: formData.zipcode,
      donation_type: formData.donation_type,
      is_ehundi: formData.is_ehundi,
      pan_no: formData.pan_no,
      processing_agency: formData.processing_agency,
    };

    // console.log(payload);

    // return;
    setAddDonationLoading(true);
    try {
      let response;
      if (isEditMode) {
        response = await axiosAPI.put(
          `/api/donation/update-donation/${currentUserId}`,
          payload,
        );
        window.notifyMessage(
          "Success",
          "Donation updated successfully",
          "success",
        );

        setSbiDonations((prevDonations) =>
          prevDonations.map((donation) =>
            donation.id === currentUserId
              ? {
                  ...donation,
                  user_id: formData.user_id,
                  transaction_date_and_time: formData.transaction_date_and_time,
                  amount: formData.amount,
                  tr_no: formData.tr_no,
                  mode: formData.mode,
                  name: formData.name,
                  email: formData.email,
                  phone_number: formData.phone_number,
                  address: formData.address,
                  zipcode: formData.zipcode,
                  donation_type: formData.donation_type,
                  pan_no: formData.pan_no,
                  processing_agency: formData.processing_agency,
                }
              : donation,
          ),
        );
      } else {
        response = await axiosAPI.post("/api/donation/add-donation", payload);
        window.notifyMessage(
          "Success",
          "Donation added successfully",
          "success",
        );
      }
      hideModal("newUserModal");
      fetchDonations();
      fetchDonationSummary();
      removeFormData();
      setAddDonationLoading(false);
      setIsEditMode(false);
      closeModal();
      setErrors({});
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        window.notifyMessage("Error", error.response.data.message, "danger");
      } else {
        window.notifyMessage("Error", "There was an error!", "danger");
      }
    }
  };

  const openUploadDonorModal = () => {
    showModal("newUserExcelModal");
  };

  // const handleExportDonations = () => {
  //   if (filters.search || (filters.from_date && filters.to_date)) {
  //     // Proceed with export
  //     downloadExcel("donations", filters); // Pass filters if needed
  //   } else {
  //     alert("Please select both From and To dates or enter a search term.");
  //   }
  // };

  const downloadExcel = async (table_name) => {
    setDownloading(true); //  Start loader
    const queryString = buildQuery();
    try {
      const response = await axiosAPI.get(
        `/api/donation/download-donation-excel?table=${table_name}&${queryString}`, //  Pass table name in query
        {
          responseType: "blob",
        },
      );

      if (response.status !== 200) {
        throw new Error("Failed to download file");
      }

      const blob = response.data;
      const url = window.URL.createObjectURL(new Blob([blob]));

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${table_name}.xlsx`); // Optional: dynamic file name
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download failed:", error);
      alert("Failed to download file. Please try again later.");
    } finally {
      setDownloading(false); // ⏹ End loader
    }
  };

  const handleDelete = async (id) => {
    const isConfirmed = window.confirm("Are you sure you want to delete this?");
    if (!isConfirmed) return;

    try {
      const response = await axiosAPI.delete(
        `/api/notification/delete-notification/${id}`,
      );
      window.notifyMessage("Success", "Deleted successfully", "success");
      // getNotifications();
    } catch (error) {
      console.error("Error deleting:", error);
      window.notifyMessage(
        "Error",
        "An error occurred while deleting.",
        "danger",
      );
    }
  };

  // console.log("Sbi donation",sbiDonations)

  const openEditModal = (id) => {
    setIsEditMode(true);
    setCurrentUserId(id);
    // Find the notification with this ID and populate the form
    const selected_donation = sbiDonations.find((donor) => donor.id === id);

    // console.log("Level one", selected_donation);

    // let TrNumber = "";

    // if (selected_donation.tr_no && !isNaN(selected_donation.tr_no)) {
    //   TrNumber = selected_donation.tr_no.toString().padStart(6, "0");
    //   TrNumber = TrNumbePrefix + TrNumber;
    // }

    setCurrentUserId(id);
    // console.log(TrNumber);

    if (selected_donation) {
      const selectedUser = data.find(
        (user) => user.id === selected_donation.user_id,
      );

      // const selectedUser = data.find(
      //   (user) => user.phone_number == selected_donation.phone_number
      // );

      // console.log("Select User", selectedUser);

      // console.log("Select User", selected_donation);
      setFormData({
        // user_id: selected_donation.user_id,
        user_id: selectedUser
          ? { value: selectedUser?.id, label: selectedUser?.full_name }
          : null,
        transaction_date_and_time: selected_donation.transaction_date_and_time,
        amount: selected_donation.amount,
        // tr_no: TrNumber,
        tr_no: selected_donation.tr_no,
        mode: selected_donation?.mode,
        email: selected_donation?.email,
        name: selected_donation?.full_name,
        phone_number: selected_donation?.phone_number,
        address: selected_donation?.address,
        zipcode: selected_donation?.zipcode,
        donation_type: selected_donation?.donation_type,
        processing_agency: selected_donation?.processing_agency,
        is_ehundi: selected_donation?.e_hundi,
      });
    }

    showModal("newUserModal");
  };

  // const openDonorFromDonation = (donorId) => {
  //   // console.log("donor id", donorId);

  //   // return;

  //   if (!donorId) {
  //     // console.log("User id", donorId);
  //     return;
  //   }

  //   navigate("/donor", {
  //     state: {
  //       openModal: true,
  //       donorId: donorId,
  //       activeTab: "donations", // ya jo tab chahiye
  //     },
  //   });
  // };

  // console.log("Fromdata is",formData)

  // Close Modal
  const closeModal = () => {
    setIsEditMode(false);
    removeFormData();
    setUploadRows("");
    setCurrentUserId(null);
  };

  const openAddModal = () => {
    showModal("newUserModal");
    fetchCurrentDateAndTime();
    // fetchCurrentTrNumber();
  };

  return (
    <div className="container">
      <div className="page-inner">
        {role === "admin" && (
          <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
            <div className="d-flex flex-column flex-md-row gap-3">
              {donationSumarry &&
                donationSumarry?.numberOfReceiptLeftResult
                  ?.filter(
                    (item) =>
                      item.table_name === "donations" ||
                      item?.table_name === "donations_online",
                  )
                  ?.map((item, index) => (
                    <div>
                      <div className="card card-stats card-round">
                        <div className="card-body">
                          <div className="row align-items-center">
                            <div className="col-icon">
                              <div
                                className={`icon-big text-center icon-danger border bubble-shadow-small`}
                              >
                                <i className="fas fa-chalkboard-teacher"></i>
                                {/* {item?.icon} */}
                              </div>
                            </div>
                            <div className="col col-stats ms-3 ms-sm-0">
                              <div className="numbers">
                                <p className="card-category">
                                  {item?.table_name === "donations"
                                    ? "Number Of Receipt Left"
                                    : ""}
                                </p>

                                <h4 className="card-title">
                                  {item?.current_tr_number}/
                                  {item?.end_tr_number}
                                </h4>

                                {item?.current_tr_number ===
                                  item?.end_tr_number && (
                                  <div className="badge badge-warning">
                                    TR limit reached. Please generate more TR
                                    numbers.
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
              {donationSumarry && (
                <div>
                  <div className="card card-stats card-round">
                    <div className="card-body">
                      <div className="row align-items-center">
                        <div className="col-icon">
                          <div className="icon-big text-center icon-success border bubble-shadow-small">
                            <i className="fas fa-donate"></i>
                          </div>
                        </div>
                        <div className="col col-stats ms-3 ms-sm-0">
                          <div className="numbers">
                            <p className="card-category">
                              Today's Total Donations
                            </p>
                            <h4 className="card-title">
                              {donationSumarry?.total_today_donations}
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="d-flex gap-3">
              <button
                type="button"
                className="btn btn-success btn-round"
                // onClick={handleExportDonations}
                onClick={() => {
                  if (
                    filters.search ||
                    (filters.from_date && filters.to_date)
                  ) {
                    downloadExcel("donations"); // Pass filters if needed
                  } else {
                    const confirmFullDownload = window.confirm(
                      "No filters applied. Do you want to download the full sheet?",
                    );
                    if (confirmFullDownload) {
                      downloadExcel("donations"); //  Full sheet export
                    }
                  }
                }}
                disabled={downloading}
              >
                Export Donations
              </button>

              {/* <button
                type="button"
                className="btn btn-success btn-round"
                onClick={() => openUploadDonorModal()}
              >
                Upload Donation
              </button> */}

              <button
                type="button"
                className="btn btn-dark btn-round"
                onClick={() => openAddModal()}
              >
                Add Donation
              </button>
            </div>
          </div>
        )}

        {/* {activeTab === "summary" ? <ManualRecurringDonationSummary /> : ""} */}

        {/* Pdf Modal */}
        {showPdfModal && (
          <div
            className="modal show d-block"
            tabIndex="-1"
            style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
          >
            <div className="modal-dialog modal-xl">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Receipt</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => {
                      setShowPdfModal(false);
                      setReceiptDetails("");
                    }}
                  ></button>
                </div>
                <div className="modal-body pb-0" ref={receiptRef}>
                  {/* Receipt Content */}

                  <div className="row mb-3">
                    <div className="col-2">
                      <img
                        // src="https://wearedeveloper.site/test/Folk/isckonkanpur-300x288-1.png"
                        src={"/isckonkanpur-300x288-1.png"}
                        alt="ISKCON Logo"
                        className="img-fluid"
                        width="150px"
                      />
                    </div>
                    <div className="col-10 text-center">
                      <h1
                        style={{
                          fontSize: "20px",
                          fontWeight: "bold",
                          color: "#a00",
                        }}
                      >
                        INTERNATIONAL SOCIETY FOR KRISHNA CONSCIOUSNESS (ISKCON)
                      </h1>
                      <h2
                        className="mb-0"
                        style={{ fontSize: "15px", fontWeight: "bold" }}
                      >
                        Founder Acharya: His Divine Grace A.C. Bhaktivedanta
                        Swami Srila Prabhupada
                      </h2>
                      <p style={{ fontSize: "14px", fontWeight: "bold" }}>
                        (Head Office: Hare Krishna Land, Juhu, Mumbai - 400 049)
                      </p>
                      <p className="mb-0" style={{ fontSize: "12px" }}>
                        Branch: Sri Sri Radha Madhav Mandir Mainavati Marg, Post
                        Kheora, Nawabganj Kanpur 208017. U.P. Ph: 7080007010
                      </p>
                      <p style={{ fontSize: "14px" }}>
                        Registered under Maharashtra Public Trust Act 1950, vide
                        Regn. No: F-2179(Bom). Unique Regn No. (80G):
                        AAATI0017PF20219
                      </p>
                    </div>
                  </div>

                  <hr />

                  <h2 className="text-center text-decoration-underline mb-3">
                    RECEIPT
                  </h2>

                  {/* Dynamic Receipt Details */}
                  <div className="row">
                    <div className="col-12 mb-1">
                      <p className="mb-2">
                        <strong>Amount: </strong>
                        {receiptDetails.amount || " ---- "}
                      </p>
                      <p className="mb-2">
                        <strong>Amount in Words: </strong>
                        {receiptDetails.amountInWords || " ---- "}
                      </p>
                      <p className="mb-2">
                        <strong>Name: </strong>
                        {receiptDetails.full_name || " ---- "}
                      </p>
                      <p className="mb-2">
                        <strong>Email: </strong>
                        {receiptDetails.email || " ---- "}
                      </p>
                      <p className="mb-2">
                        <strong>Phone Number: </strong>
                        {receiptDetails?.phone_number || " ---- "}
                      </p>
                      <p className="mb-2">
                        <strong>Address : </strong>
                        {receiptDetails?.address || " ---- "}
                      </p>
                      <p className="mb-2">
                        <strong>Pincode : </strong>
                        {receiptDetails?.zipcode || " ---- "}
                      </p>
                      <p className="mb-2">
                        <strong>Mode Of Payment: </strong>
                        {receiptDetails.modeOfPayment}
                      </p>
                      <p className="mb-2">
                        <strong>Tr Number: </strong>
                        {receiptDetails?.tr_number}
                      </p>
                      <p className="mb-2">
                        <strong>Pan No: </strong>
                        {receiptDetails?.pan_no || " ---- "}
                      </p>

                      {/* <p>
                        <strong>Received with thanks from: </strong>{receiptDetails?.receiver}
                      </p> */}
                      <p className="mb-2">
                        <strong>Date: </strong>
                        {receiptDetails.date
                          ? receiptDetails.date.split(" ")[0]
                          : ""}
                      </p>
                    </div>
                  </div>
                  <hr />
                  <div className="mt-4">
                    <p className="mb-1">
                      <h5>
                        Purpose of Donation:
                        {receiptDetails?.purpose_of_donation}
                      </h5>
                    </p>
                    <p className="mb-1">
                      <strong>Yours in the service of Lord Sri Krishna.</strong>
                    </p>
                    <p>
                      <em>
                        Note: This is a computer-generated receipt. No signature
                        is required.
                      </em>
                    </p>
                    <p className="text-danger font-weight-bold text-center">
                      Hare Krishna Hare Krishna Krishna Krishna Hare Hare Hare
                      Rama Hare Rama Rama Rama Hare Hare
                    </p>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    className="btn btn-success"
                    onClick={downloadPdf} // Trigger the function to download the PDF
                  >
                    Download PDF
                  </button>
                  <button
                    className="btn btn-secondary"
                    onClick={() => setShowPdfModal(false)}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Modal */}
        <div
          className="modal fade"
          id="newUserModal"
          tabIndex="-1"
          aria-labelledby="newUserModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-xl">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="newUserModalLabel">
                  {isEditMode ? "Edit Donation" : "Add Donation"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={closeModal}
                ></button>
              </div>
              <div className="modal-body">
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    {/* Donor Select */}
                    <div className="mb-3 col-md-6">
                      <label htmlFor="user_id" className="form-label">
                        Select Donor
                      </label>
                      <AsyncSelect
                        cacheOptions
                        defaultOptions={filteredOptions}
                        loadOptions={loadOptions}
                        // onChange={(selectedOption) =>
                        //   setFormData((prev) => ({
                        //     ...prev,
                        //     user_id: selectedOption,
                        //     phone_number: selectedOption?.label
                        //       .split("-")[1]
                        //       .trim(),
                        //     name: selectedOption?.label.split("-")[0].trim(),
                        //     donation_type: "manual_recurring_donation",
                        //   }))
                        // }

                        onChange={(selectedOption) => {
                          if (selectedOption?.flag === "yes") {
                            // Mapped lead selected
                            setFormData((prev) => ({
                              ...prev,
                              user_id: "",
                              // user_id:selectedOption,
                              phone_number: selectedOption.phone_number || "",
                              name: selectedOption.full_name || "",
                              donation_type: "one_time_donations",
                            }));
                          } else {
                            // Normal donor selected
                            setFormData((prev) => ({
                              ...prev,
                              user_id: selectedOption,
                              phone_number: selectedOption?.label
                                .split("-")[1]
                                .trim(),
                              name: selectedOption?.label.split("-")[0].trim(),
                              donation_type: "manual_recurring_donation",
                            }));
                          }
                        }}
                        value={formData.user_id}
                        isClearable
                        placeholder="-- Select Donor ---"
                      />
                    </div>

                    <div className="mb-3 col-md-6">
                      <label htmlFor="donation_type" className="form-label">
                        Donation Type
                      </label>
                      <select
                        className="form-select"
                        id="donation_type"
                        name="donation_type"
                        required
                        value={formData.donation_type}
                        onChange={handleChange}
                      >
                        <option value="one_time_donation">
                          One Time Donation
                        </option>
                        <option value="manual_recurring_donation">
                          Manual Recurring Donation
                        </option>
                      </select>
                    </div>
                  </div>

                  <div className="row">
                    {/* Name */}
                    <div className="mb-3 col-md-6">
                      <label htmlFor="name" className="form-label">
                        Name
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        required
                        id="name"
                        name="name"
                        placeholder="Full name (First and Last)"
                        value={formData.name}
                        onChange={handleChange}
                      />
                    </div>
                    {/* Phone Number */}
                    <div className="mb-3 col-md-6">
                      <label htmlFor="phone_number" className="form-label">
                        Phone Number
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="phone_number"
                        name="phone_number"
                        placeholder="Phone number (e.g., +1 234 567 8901)"
                        value={formData.phone_number}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  {/* Address */}
                  <div className="mb-3">
                    <label htmlFor="address" className="form-label">
                      Address{" "}
                      <small className="text-muted">
                        (max 120 characters)
                      </small>{" "}
                    </label>
                    <textarea
                      className="form-control"
                      id="address"
                      name="address"
                      maxLength={120}
                      placeholder="Enter your address (e.g., 123 Main St, City)"
                      value={formData.address}
                      onChange={handleChange}
                      rows={3} // You can increase this number as needed
                    ></textarea>
                  </div>

                  <div className="row">
                    {/* Email */}
                    <div className="mb-3 col-md-6">
                      <label htmlFor="email" className="form-label">
                        Email
                      </label>
                      <input
                        type="email"
                        className="form-control"
                        id="email"
                        name="email"
                        placeholder="Email address (e.g., john@example.com)"
                        value={formData.email}
                        onChange={handleChange}
                      />
                    </div>
                    {/* Pincode */}
                    <div className="mb-3 col-md-6">
                      <label htmlFor="zipcode" className="form-label">
                        Pincode
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="zipcode"
                        name="zipcode"
                        placeholder="Enter your area zipcode (e.g., 110001)"
                        value={formData.zipcode}
                        onChange={handleChange}
                        maxLength={6} // optional: for Indian zipcodes
                      />
                    </div>

                    {/* Date & Time */}
                    <div className="mb-3 col-md-6">
                      <label
                        htmlFor="transaction_date_and_time"
                        className="form-label"
                      >
                        Date & Time
                      </label>
                      <input
                        type="datetime-local"
                        className="form-control"
                        id="transaction_date_and_time"
                        name="transaction_date_and_time"
                        value={formData.transaction_date_and_time}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    {/* Amount */}
                    <div className="mb-3 col-md-6">
                      <label htmlFor="amount" className="form-label">
                        Amount
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        id="amount"
                        required
                        name="amount"
                        readOnly={isEditMode} // Make readOnly in edit mode
                        placeholder="Enter Donation Amount"
                        value={formData.amount}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className="row">
                    {/* TR No */}
                    {/* <div className="mb-3 col-md-6">
                      <label htmlFor="tr_no" className="form-label">
                        TR No
                      </label>

                      <input
                        type="text"
                        // readOnly
                        className="form-control"
                        id="tr_no"
                        name="tr_no"
                        placeholder="Enter tr number"
                        value={formData.tr_no}
                        onChange={handleChange}
                      />
                      <small className="text-danger d-block mb-1">
                        Note: If this TR number field is left blank, a TR number
                        will be generated automatically.
                      </small>
                    </div> */}

                    {/* Mode */}
                    <div className="mb-3 col-md-6">
                      <label htmlFor="mode" className="form-label">
                        Mode
                      </label>
                      <select
                        className="form-select"
                        id="mode"
                        name="mode"
                        required
                        value={formData.mode}
                        onChange={handleChange}
                      >
                        <option value="">Select Mode</option>
                        {!modesLoading &&
                          modes.map((m) => (
                            <option key={m.id || m.name} value={m.name}>
                              {m.name}
                            </option>
                          ))}
                      </select>
                    </div>

                    <div className="mb-3 col-md-6">
                      <label htmlFor="mode" className="form-label">
                        E-Hundi
                      </label>
                      <select
                        className="form-select"
                        id="is_ehundi"
                        name="is_ehundi"
                        value={formData.is_ehundi}
                        onChange={handleChange}
                      >
                        <option value="no">No</option>
                        <option value="yes">Yes</option>
                      </select>
                    </div>
                  </div>

                  <div className="row">
                    {/* Pan no */}
                    <div className="mb-3 col-md-6">
                      <label htmlFor="pan_no" className="form-label">
                        Pan No
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="pan_no"
                        required
                        name="pan_no"
                        placeholder="Enter Pan Number"
                        value={formData.pan_no}
                        onChange={handleChange}
                      />
                    </div>
                    {/* Processing Agency Dropdown */}
                    <div className="mb-3 col-md-6">
                      <label className="form-label mb-1">
                        Processing Agency
                      </label>
                      <select
                        className="form-select"
                        value={formData.processing_agency}
                        id="processing_agency"
                        onChange={handleChange}
                        style={{ width: "100%" }}
                      >
                        <option value="">All Agency</option>
                        {!agenciesLoading &&
                          agencies.map((agency) => (
                            <option key={agency.id} value={agency.name}>
                              {agency.name}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>

                  <button
                    type="submit"
                    disabled={addDonationLoading}
                    className="btn btn-primary btn-round btn-sm"
                  >
                    {addDonationLoading ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        {isEditMode ? "Updating..." : "Adding..."}
                      </>
                    ) : isEditMode ? (
                      "Update Donation"
                    ) : (
                      "Add Donation"
                    )}
                  </button>

                  {/* <button
                    type="submit"
                    disabled={loading}
                    className="btn btn-primary btn-round btn-sm"
                  >
                    {isEditMode ? "Update  Donation" : "Add  Donation"}
                  </button> */}
                </form>
              </div>
            </div>
          </div>
        </div>

        {/* Add Donor Modal */}
        <div
          className="modal fade"
          id="newUserExcelModal"
          tabIndex="-1"
          aria-labelledby="newUserModalLabel"
          aria-hidden="true"
        >
          <div
            className={`modal-dialog ${
              view === "manual"
                ? "modal-fullscreen"
                : "modal-dialog-centered modal-dialog-scrollable modal-md"
            }`}
          >
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="newUserModalLabel">
                  {isEditMode ? "Edit Donation" : "Upload Donation"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    closeModal();
                    setView("excel");
                  }}
                ></button>
              </div>

              <div className="modal-body">
                {view === "excel" && (
                  <>
                    {/* Excel Upload UI */}
                    <div className="mb-3">
                      <label htmlFor="excelUpload" className="form-label">
                        Upload Excel File (.xlsx)
                      </label>
                      <input
                        type="file"
                        className="form-control"
                        id="excelUpload"
                        accept=".xlsx"
                        ref={fileInputRef}
                        onChange={handleExcelFileChange}
                      />
                      <div className="mt-3">
                        <button
                          type="button"
                          className="btn btn-link p-0 text-primary"
                          onClick={() => {
                            const link = document.createElement("a");
                            link.href = "/samples/donation_sample.xlsx";
                            link.download = "donation_sample.xlsx";
                            link.click();
                          }}
                        >
                          Download Sample Sheet
                        </button>
                      </div>
                      <hr />
                      <small className="form-text font-bold text-danger">
                        Mode can be in format like <strong>CASH</strong>,{" "}
                        <strong>UPI</strong>, <strong>Online</strong>
                      </small>

                      <br />
                      <button
                        className="btn btn-success mt-3"
                        onClick={handleExcelSubmit} // Submit to backend
                      >
                        Upload
                      </button>
                      {message && <div className="mt-2">{message}</div>}
                      {/* Display any messages */}

                      {uploadRows.length > 0 && (
                        <div className="mt-3">
                          <h5>Upload Summary:</h5>
                          <table className="table table-bordered table-striped">
                            <thead>
                              <tr>
                                <th>#</th>
                                <th>Row</th>
                                <th>Status</th>
                                <th>Reason</th>
                              </tr>
                            </thead>
                            <tbody>
                              {uploadRows.map((rowData, index) => (
                                <tr key={index}>
                                  <td>{index + 1}</td>
                                  <td>{rowData?.row}</td>
                                  <td
                                    style={{
                                      color:
                                        rowData?.status === "fail"
                                          ? "red"
                                          : "green",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    {rowData?.status}
                                  </td>
                                  <td>{rowData?.reason || "-"}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      )}
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>

        {downloading && <Loader />}

        {/* Donation Table */}
        {activeTab != "summary" && (
          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <div className="card-header d-flex flex-wrap justify-content-between align-items-end gap-3">
                  {/* Left: Title */}
                  <h4 className="card-title mb-0">
                    All One Time Donations ({sbiDonations.length})
                  </h4>

                  {/* Right: All filters including search */}
                  <div className="d-flex flex-wrap align-items-end gap-3 ms-auto">
                    {/* Search Bar */}
                    {role === "admin" && (
                      <div
                        className="position-relative"
                        style={{ width: "320px" }}
                      >
                        <input
                          className="form-control shadow-sm px-3 py-2  border-2 w-100"
                          type="text"
                          placeholder="Enter name or phone_number or donor ID..."
                          value={filters.search}
                          onChange={(e) =>
                            handleFilterChange("search", e.target.value)
                          }
                          style={{ paddingRight: "110px" }}
                        />
                      </div>
                    )}

                    {/* From Date */}
                    <div className="d-flex flex-column">
                      <label htmlFor="fromDate" className="form-label mb-1">
                        From
                      </label>
                      <input
                        id="fromDate"
                        type="date"
                        className="form-control"
                        value={filters.from_date || ""}
                        onChange={(e) =>
                          handleFilterChange("from_date", e.target.value)
                        }
                      />
                    </div>

                    {/* To Date */}
                    <div className="d-flex flex-column">
                      <label htmlFor="toDate" className="form-label mb-1">
                        To
                      </label>
                      <input
                        id="toDate"
                        type="date"
                        className="form-control"
                        value={filters.to_date || ""}
                        onChange={(e) =>
                          handleFilterChange("to_date", e.target.value)
                        }
                      />
                    </div>

                    {/* Filter Button */}
                    <button
                      className="btn btn-primary rounded-pill px-4"
                      style={{ height: "38px" }}
                      onClick={() => {
                        if (
                          filters.search ||
                          (filters.from_date && filters.to_date)
                        ) {
                          setPage(1);
                          fetchDonations();
                        } else {
                          alert("Please select both From and To dates.");
                        }
                      }}
                    >
                      Filter
                    </button>

                    {/* Reset Button */}
                    <button
                      className="btn btn-icon btn-round btn-dark py-3 px-3"
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      title="Reset Filters"
                      onClick={handleResetFilters}
                    >
                      <i className="fas fa-sync-alt"></i>
                    </button>
                  </div>
                </div>

                <div className="card-body">
                  <div className="table-responsive">
                    <table className="table table-striped">
                      <thead>
                        <tr>
                          <th>Name</th>
                          {/* <th>Agency Name</th> */}
                          <th>Mode</th>
                          <th>Donation Type</th>
                          <th>E-Hundi</th>
                          <th>Amount</th>
                          <th>Date</th>

                          {/* <th>Subscription_Expiry_Date</th> */}
                          {/* <th>Created At</th> */}
                          <tr>
                            {role === "admin" && (
                              <th>Action</th> // Show this if the role is "admin"
                            )}
                          </tr>
                        </tr>
                      </thead>
                      <tbody>
                        {loading ? (
                          <tr>
                            <td colSpan="5" className="text-center">
                              <Loader />
                            </td>
                          </tr>
                        ) : sbiDonations.length == 0 ? (
                          <tr>
                            <td colSpan="5" className="text-center">
                              No Data Found
                            </td>
                          </tr>
                        ) : (
                          sbiDonations?.map((sbi) => {
                            const formattedDate = new Date(
                              sbi.transaction_date_and_time,
                            ).toLocaleDateString("en-GB", {
                              day: "2-digit",
                              month: "short",
                              year: "numeric",
                            });

                            // Check if the message length is greater than 50 characters
                            //   const truncatedMessage =
                            //     sbi.sbiication_message.length > 50
                            //       ? sbi.sbiication_message.slice(0, 50) + "..."
                            //       : sbi.sbiication_message;

                            return (
                              <tr key={sbi.id}>
                                <td>{sbi.full_name}</td>
                                {/* <td>{sbi.processing_agency}</td> */}
                                <td>{sbi.mode}</td>
                                <td>
                                  {sbi?.donation_type
                                    ?.split("_")
                                    ?.join(" ")
                                    ?.toUpperCase()}
                                </td>
                                <td>{sbi?.e_hundi}</td>
                                <td>{sbi.amount}</td>
                                <td>{formattedDate}</td>
                                {/* <td>{formattedDate}</td> */}
                                {/* <td>{truncatedMessage}</td> */}
                                <td>
                                  <button
                                    className="btn btn-dark btn-round btn-icon btn-sm me-2"
                                    onClick={() => openReceiptModal(sbi.id)}
                                  >
                                    <i className="fas fa-download"></i>
                                  </button>
                                  {role === "admin" && (
                                    <button
                                      className="btn btn-icon btn-round btn-dark btn-sm me-2"
                                      onClick={() => openEditModal(sbi.id)}
                                    >
                                      <i className="fas fa-edit"></i>
                                    </button>
                                  )}
                                  {/* {role === "admin" && (
                                    <button
                                      className="btn btn-icon btn-round btn-dark btn-sm me-2"
                                      onClick={() =>
                                        openDonorFromDonation(sbi.user_id)
                                      }
                                    >
                                      <i className="fas fa-eye"></i>
                                    </button>
                                  )} */}
                                  {/* <button
                                  className="btn btn-icon btn-round btn-danger btn-sm me-2"
                                  onClick={() => handleDelete(sbi.id)}
                                >
                                  <i className="fas fa-trash"></i>
                                </button> */}
                                  {/* {role === "admin" && (
                                  <button
                                    className="btn btn-icon btn-round btn-danger btn-sm me-2"
                                    onClick={() => handleDelete(sbi.id)}
                                  >
                                    <i className="fas fa-trash"></i>
                                  </button>
                                )} */}
                                </td>
                              </tr>
                            );
                          })
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              {/* Pagination */}
              <Pagination
                page={page}
                totalPages={totalPages}
                handlePageClick={handlePageClick}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Donations;
